function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  const activeTab = document.getElementById(tabName);
  if (!activeTab) return;
  activeTab.style.display = "block";
  const deferredContent = activeTab.querySelector("template[data-rg-tab-content]");
  if (deferredContent) deferredContent.replaceWith(deferredContent.content);
  evt.currentTarget.className += " active";
  const collectionUrl = evt.currentTarget.dataset.rgCollectionUrl;
  if (collectionUrl) {
    const section = evt.currentTarget.closest('[data-section-id]');
    const viewAll = section && section.querySelector('[data-rg-collection-view-all]');
    if (viewAll) viewAll.setAttribute('href', collectionUrl);
  }
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});
window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});


